import Breadcrumbs from '@/components/Breadcrumbs/breadcrumbs.example';

export default Breadcrumbs;
